import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  Link,
} from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import { LoadingProvider } from "./context/LoadingContext";
import AxiosInterceptor from "./utility/AxiosInterceptor";
import GlobalLoader from "./components/GlobalLoader";
import ProtectedRoute from "./utility/ProtectedRoute";
import Home from "./components/Home";
import Application from "./components/Application";
import Step_one from "./components/Step_one";
import Step_oneB from "./components/Step_oneB";
import Step_two from "./components/Step_two";
import Step_three from "./components/Step_three";
import Step_four from "./components/Step_four";
import Step_five from "./components/Step_five";
import Step_six from "./components/Step_six";
import Step_seven from "./components/Step_seven";
import ApplicationStatus from "./components/applicationStatus";
import Continue from "./components/Continue";
import AnuaniYaSasa from "./components/anuani_ya_sasa";
import HabariZaSafari from "./components/habari_za_safari";
import SelfeDeclaration from "./components/SelfPrintingDeclaration";
import BillInformations from "./components/payments";
import EmailVerification from "./components/EmailValidation";
import DocumentVerification from "./components/DocumentVerification";
import VerificationQR from "./components/VerificationQR";
import bg from "./assets/bg.jpg";
import UploadPhotoComponent from "./components/upload_photo_";
import InputSecurity from "./utility/InputSecurity";

const PreventNavigation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      navigate(1); // Forces the user to stay on the same page
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return null;
};

//   // Prevent forward/backward navigation
//   useEffect(() => {
//     window.history.pushState(null, null, window.location.href);
//     window.onpopstate = function () {
//       window.history.pushState(null, null, window.location.href);
//     };
//   }, []);

const NotFound = () => {
  return (
    <div style={styles.container}>
      <h1>Oops! Page not found.</h1>
      <Link to="/" style={styles.link}>
        <button style={styles.button}>Go to Home</button>
      </Link>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${bg})`,
    backgroundAttachment: "fixed",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#007BFF",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    textAlign: "center",
    marginTop: "20px",
  },
  link: {
    textDecoration: "none",
  },
};

function App() {
  return (
    <LoadingProvider>
      <AxiosInterceptor />
      <GlobalLoader />
      <InputSecurity />
      <Router>
        <PreventNavigation />
        <NotificationContainer />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route
          path="/emailverification"
          element={<ProtectedRoute element={<EmailVerification />} />}
        />
        <Route
          path="/docmentVerification"
          element={<ProtectedRoute element={<DocumentVerification />} />}
        />
        <Route
          path="/qrverification"
          element={<ProtectedRoute element={<VerificationQR />} />}
        />
        <Route
          path="/application"
          element={<ProtectedRoute element={<Application />} />}
        />
        <Route
          path="/stp1"
          element={<ProtectedRoute element={<Step_one />} />}
        />
        <Route
          path="/stp1B"
          element={<ProtectedRoute element={<Step_oneB />} />}
        />
        <Route
          path="/stp2"
          element={<ProtectedRoute element={<Step_two />} />}
        />
        <Route
          path="/stp3"
          element={<ProtectedRoute element={<Step_three />} />}
        />
        <Route
          path="/stp4"
          element={<ProtectedRoute element={<Step_four />} />}
        />
        <Route
          path="/stp5"
          element={<ProtectedRoute element={<Step_five />} />}
        />
        <Route
          path="/upload-photo"
          element={<ProtectedRoute element={<UploadPhotoComponent />} />}
        />
        <Route
          path="/stp6"
          element={<ProtectedRoute element={<Step_six />} />}
        />
        <Route
          path="/stp7"
          element={<ProtectedRoute element={<Step_seven />} />}
        />
        <Route
          path="/stp10"
          element={<ProtectedRoute element={<ApplicationStatus />} />}
        />
        <Route
          path="/continue"
          element={<ProtectedRoute element={<Continue />} />}
        />
        <Route
          path="/billInfo"
          element={<ProtectedRoute element={<BillInformations />} />}
        />
        <Route
          path="/taarifa_za_safari"
          element={<ProtectedRoute element={<HabariZaSafari />} />}
        />
        <Route
          path="/anuani_ya_sasa"
          element={<ProtectedRoute element={<AnuaniYaSasa />} />}
        />
        <Route
          path="/selfDeclaration"
          element={<ProtectedRoute element={<SelfeDeclaration />} />}
        />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </LoadingProvider>
  );
}

export default App;
